<div class="gradient-top">
    <h2 i18n>Captcha</h2>
    <form (ngSubmit)="onNext(f)" #f="ngForm">
        <img
            id="captchaImg"
            name="captchaImg"
            src="{{ captchaImgUrl }}"
            alt="Captcha"
            #captchaImg />
        <mat-form-field
            [class.form-group--error]="
                !captchaCode.valid && captchaCode.touched && captchaCode.errors
            "
            subscriptSizing="dynamic">
            <input
                matInput
                type="text"
                id="captchaCode"
                name="captchaCode"
                ngModel
                required
                #captchaCode="ngModel" />
            @if (!captchaCode.valid && captchaCode.touched && captchaCode.errors) {
                <mat-error>
                    @if (captchaCode.errors.required) {
                        <ng-container i18n> Text z obrázku je nutné přepsat. </ng-container>
                    }
                    @if (captchaCode.errors.errorCode === msgCodes.msgCaptchaInvalidCode) {
                        <ng-container i18n>
                            Chyba při ověření captcha. Zkontrolujte kód a&nbsp;zkuste to znovu.
                        </ng-container>
                    }
                    @if (captchaCode.errors.errorCode === msgCodes.msgCaptchaCallError) {
                        <ng-container i18n> Chyba při volání captcha! </ng-container>
                    }
                </mat-error>
            }
        </mat-form-field>

        <div class="bb">
            <div class="u-btn u-bu-bigger">
                <button i18n (click)="onCancel()">Zrušit</button>
            </div>
            <div class="u-btn u-bu-bigger">
                <button i18n type="submit">Odeslat</button>
            </div>
        </div>
    </form>
</div>
